import { useMemo } from 'react'
import agendaSchedulePersonas from '../../helpers/calendar/agendaSchedulePersonas'
import visibleAgendaDocs from '../../helpers/calendar/visibleAgendaDocs'

// Wiens rooster een agenda toont en tot wanneer, plus de taken die er dan
// overblijven. Nodig omdat vier agenda's (useAgendaData, de mobiele agenda,
// de dashboardkaart en de tijdkiezer bij het inplannen) dit elk zelf deden —
// en de kaart en de tijdkiezer helemaal niet, waardoor die het rooster van
// iedereen toonden, ook van wie al lang uitgestroomd was.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook

/**
 * @typedef {object} AgendaSchedule
 * @property {Array<object>} visibleDocs - De taken die de agenda toont
 * @property {Array<object>} schedulePersonas - Deelnemers van wie het rooster in beeld hoort
 * @property {Array<string>} schedulePersonaIds - Hun `ID`, voor afwezigheid en filters
 * @property {Record<string, Date>} scheduleEndByPersonaId - Laatste roosterdag per uitgestroomde deelnemer; geef door aan `CalendarView`
 */

/**
 * @param {Array<object>|null|undefined} personas - Alle deelnemers
 * @param {Array<object>|null|undefined} docs - De taken binnen het zichtbare bereik
 * @param {Date} [periodStart] - Begin van de getoonde periode
 * @returns {AgendaSchedule}
 */
const useAgendaSchedule = (personas, docs, periodStart) => {
    const { personas: schedulePersonas, endById: scheduleEndByPersonaId } = useMemo(
        () => agendaSchedulePersonas(personas, periodStart),
        [personas, periodStart]
    )

    const schedulePersonaIds = useMemo(
        () => schedulePersonas.map((persona) => persona?.ID).filter(Boolean),
        [schedulePersonas]
    )

    const visibleDocs = useMemo(
        () => visibleAgendaDocs(docs, schedulePersonaIds),
        [docs, schedulePersonaIds]
    )

    return { visibleDocs, schedulePersonas, schedulePersonaIds, scheduleEndByPersonaId }
}

export default useAgendaSchedule
